import { isDefined } from "@clipboard-health/util-ts";
import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";

interface UseArrivalTimePointsParams {
  workerId: string;
  qualification?: string;
}

export interface ArrivalTimePoints {
  latePointsDeduction: number;
  onTimePointsReward: number;
}

export function useArrivalTimePoints({ workerId, qualification }: UseArrivalTimePointsParams) {
  const { data: profile, ...query } = useGetClipboardScoreProfile(
    workerId,
    {
      enabled: isDefined(qualification),
    },
    qualification
  );

  const latePointsDeduction = profile?.policy?.latenessConfig?.sort(
    (a, b) => (a.minutesLateRange?.startFrom ?? 0) - (b.minutesLateRange?.startFrom ?? 0)
  )?.[0]?.points;
  const onTimePointsReward = profile?.policy?.shiftClockInConfig?.points;

  const isLoadingAndEnabled = query.isLoading && query.fetchStatus !== "idle";

  return {
    ...query,
    isLoading: isLoadingAndEnabled,
    data:
      isDefined(latePointsDeduction) && isDefined(onTimePointsReward)
        ? {
            latePointsDeduction,
            onTimePointsReward,
          }
        : undefined,
  };
}
